<template>
    <VListItemAvatar v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot />
    </VListItemAvatar>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-list-item-avatar';

export default {
    name: 'SrListItemAvatar',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>
